import { useIsAggregatedAirline } from "../../../hooks/useIsAggregatedAirline";
import { useSelectedAirline } from "../../../hooks/useSelectedAirline";
import { MultiSeriesAverageDiscountLoader } from "./MultiSeriesAverageDiscountLoader";
import { SingleSeriesAverageDiscountLoader } from "./SingleSeriesAverageDiscountLoader";

export type AverageDiscountChartLoaderProps = {
  from: Date;
  to: Date;
};

export const AverageDiscountChartLoader = ({ from, to }: AverageDiscountChartLoaderProps) => {
  const isAggregatedAirline = useIsAggregatedAirline();
  const { selectedAirlineCodes } = useSelectedAirline({ useSuspense: true });

  if (isAggregatedAirline && selectedAirlineCodes.length > 1) {
    return <MultiSeriesAverageDiscountLoader from={from} to={to} />;
  }

  return <SingleSeriesAverageDiscountLoader from={from} to={to} />;
};
